import { render, staticRenderFns } from "./EventModalEdoSettings.vue?vue&type=template&id=08ab53ca"
import script from "./EventModalEdoSettings.vue?vue&type=script&lang=js"
export * from "./EventModalEdoSettings.vue?vue&type=script&lang=js"
import style0 from "./EventModalEdoSettings.vue?vue&type=style&index=0&id=08ab53ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports